import Vue from 'vue';
import Moment from 'moment';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength } from 'vuelidate/lib/validators';
import { CLASSES_STORE } from '@/classes/store/classes.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { Grade } from '@/course-templates/types/course-template.type';
import { AutocompleteOptions } from '@/interfaces/ed-autocomplete-options';

@Component({
  name: 'ed-create-class'
})
export default class EdCreateClassComponent extends Vue {

  /* Props */
  @Prop() readonly department: number;
  @Prop() readonly orgId: number;

  /* Data */
  public form: any = {}
  public isSaving: boolean = false
  public teachersOrg: any = []
  public teachersObject: any = []
  public grades: Grade[] = []
  public schoolCalendarList: AutocompleteOptions[] = []

  /* Computed */
  get userId(): number {
    return this.$store.state.AuthStore.user.id
  }

  /* Methods */
  private init(gradeId = '',className = '', departmentName = this.department['name'] || '') {
    this.form = EdFormModel([
      EdInputModel('departmentName', departmentName),
      EdInputModel('className', className, {required, maxLength: maxLength(60)}),
      EdInputModel('gradeId', gradeId || (this.grades[0]?.id || ''), ),
      EdInputModel('schoolCalendarId', '',),
      EdInputModel('teacherId', this.userId ?? '', ),
    ]);
  }

  public cancel() {
    this.$edEventBus.$emit('closeCreateClass');
    this.init();
  }
  
  public save() {
    this.isSaving = true;
    let formData = {
      'name': this.form['className'].value,
      'gradeLevelId': this.form.gradeId.value,
      'schoolDayId': this.form.schoolCalendarId.value,
      'departmentId': this.department['id'],
      'teacherId': this.form.teacherId.value,
      'visibility': 'PUBLIC',
      'enrollment': 'OPEN',
      'capacity': null,
      'studentIds': [
      ],
      'coInstructorIds': [
      ],
      'contentIds': [
      ]
    }
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.CREATE_CLASS_A}`, formData).then((res) => {
      this.isSaving = false;
      this.$edEventBus.$emit('closeCreateClass');
      this.init();
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.success.classAdded')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
    }).catch(() => {
      this.$edEventBus.$emit('closeCreateClass');
      this.isSaving = false;
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.errors.classNoAdded')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    })
  }

  // Computed properties
  get formattedGrades(): AutocompleteOptions[] {
    return this.grades.map((grade) => ({
      value: grade.id,
      text: grade.name,
    }));
  }
  
  /* Hooks */
  async created() {
    const gradesPromise = await this.$CourseTemplates.Store.getGradeLevels(this.orgId);
    const schoolCalendarPromise = await this.$CourseTemplates.Services.getSchoolCalendarOpt(this.orgId);
    const [grades, schoolCalendar] = await Promise.all([gradesPromise, schoolCalendarPromise]);
    this.grades = grades
    this.init(grades[0]?.id || '')
    let format = 'MMMM, YYYY';
    this.schoolCalendarList = schoolCalendar.map(calendar => {
      return {
        text: Moment(calendar.startDate).format(format) + ' - ' +  Moment(calendar.endDate).format(format),
        value: calendar.schoolDayId,
      } 
    });

    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.SEARCH_USERS_ORGANIZATION_A}`,{
      orgId: this.orgId,
      userTypes: 'TEACHER,SDA,SA'
    }).then((res) => {
      this.teachersOrg = res.content;
      this.teachersObject = res.content.map(el => { 
        return {
          text: el.firstName,
          value:  el.personId
        }
      })
    }).catch(() => {
      this.teachersOrg = []
      this.teachersObject = []
    })
  }

  /* Watch */
  @Watch('department')
  setDepartment() {
    this.init();
  }
}